import React, { Component } from 'react';

class Features extends Component {
  render() {
    return (
      <div className='cm-features'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-xl-4 col-md-6'>
              <div className='block d-flex align-items-center'>
                <span className='icon bg-primary'>
                  <img src={process.env.PUBLIC_URL + '/assets/images/features/01.png'} alt='' loading="lazy" />
                </span>
                <div>
                  <h4 className='text-dark mb-10'>iPhones & Cellulars</h4>
                  <p>Screen and battery replacements for the most common phones.</p>
                </div>
              </div>
              {/* features item */}
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='block d-flex align-items-center'>
                <span className='icon bg-primary'>
                  <img src={process.env.PUBLIC_URL + '/assets/images/features/02.png'} alt='' loading="lazy" />
                </span>
                <div>
                  <h4 className='text-dark mb-10'>IPads & Tablets</h4>
                  <p>Make your charging problems go away, or get that screen fixed.</p>
                </div>
              </div>
              {/* features item */}
            </div>
            <div className='col-xl-4 col-md-6'>
              <div className='block d-flex align-items-center'>
                <span className='icon bg-primary'>
                  <img src={process.env.PUBLIC_URL + '/assets/images/features/03.png'} alt='' loading="lazy" />
                </span>
                <div>
                  <h4 className='text-dark mb-10'>Macbooks & Laptops</h4>
                  <p>Speed up you old computer, or bring a dead one back to life.</p>
                </div>
              </div>
              {/* features item */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Features;
